
import {
  useMemo,
  useState,
} from "react";


const DEFAULT_FILTERS = {
  roomTypes: [],
  maxPrice: 15000,
  guests: 1,
  sortBy: "popular",
};


const useBookingFilters = ({
  rooms = [],
}) => {

  const [filters, setFilters] =
    useState(
      DEFAULT_FILTERS
    );


  /* =========================================================
     FILTER ROOMS
  ========================================================= */

  const filteredRooms =
    useMemo(() => {

      let filtered =
        [...rooms];


      /* =====================================================
         ROOM CATEGORY
      ===================================================== */

      if (
        filters.roomTypes?.length > 0
      ) {

        filtered =
          filtered.filter(
            (room) =>
              filters.roomTypes.includes(
                room.category ||
                room.name ||
                room.type
              )
          );

      }


      /* =====================================================
         PRICE
      ===================================================== */

      if (
        filters.maxPrice
      ) {

        filtered =
          filtered.filter(
            (room) =>
              Number(
                room.price || 0
              ) <=
              Number(
                filters.maxPrice
              )
          );

      }


      /* =====================================================
         GUESTS
      ===================================================== */

      if (
        filters.guests
      ) {

        filtered =
          filtered.filter(
            (room) =>
              Number(
                room.guests || 0
              ) >=
              Number(
                filters.guests
              )
          );

      }


      /* =====================================================
         SORT: PRICE LOW
      ===================================================== */

      if (
        filters.sortBy ===
        "priceLow"
      ) {

        filtered.sort(
          (a, b) =>
            Number(
              a.price || 0
            ) -
            Number(
              b.price || 0
            )
        );

      }


      /* =====================================================
         SORT: PRICE HIGH
      ===================================================== */

      if (
        filters.sortBy ===
        "priceHigh"
      ) {

        filtered.sort(
          (a, b) =>
            Number(
              b.price || 0
            ) -
            Number(
              a.price || 0
            )
        );

      }


      /* =====================================================
         SORT: RATING
      ===================================================== */

      if (
        filters.sortBy ===
        "rating"
      ) {

        filtered.sort(
          (a, b) =>
            Number(
              b.rating || 0
            ) -
            Number(
              a.rating || 0
            )
        );

      }


      /* =====================================================
         SORT: POPULAR
      ===================================================== */

      if (
        filters.sortBy ===
        "popular"
      ) {

        filtered.sort(
          (a, b) =>
            Number(
              b.reviews || 0
            ) -
            Number(
              a.reviews || 0
            )
        );

      }


      return filtered;

    }, [
      rooms,
      filters,
    ]);


  /* =========================================================
     TOGGLE ROOM TYPE
  ========================================================= */

  const toggleRoomType =
    (type) => {

      setFilters(
        (previous) => {

          const currentTypes =
            previous.roomTypes || [];


          if (
            currentTypes.includes(
              type
            )
          ) {

            return {

              ...previous,

              roomTypes:
                currentTypes.filter(
                  (item) =>
                    item !== type
                ),

            };

          }


          return {

            ...previous,

            roomTypes: [
              ...currentTypes,
              type,
            ],

          };

        }
      );

    };


  /* =========================================================
     RESET FILTERS
  ========================================================= */

  const resetFilters =
    () => {

      setFilters({
        ...DEFAULT_FILTERS,
        roomTypes: [],
      });

    };


  return {

    filters,

    setFilters,

    filteredRooms,

    toggleRoomType,

    resetFilters,

  };
};


export default useBookingFilters;
